import React, { useState, useRef, useEffect } from "react";

import { Button, Modal, Image } from "react-bootstrap";
import { AlertDanger } from "../../Alerts/Alert";
import { Link } from "react-router-dom";
import userAvatarUpload from "../../../apis/userAvatarUpload";
import { toast } from "react-toastify";
import { useAuthContext } from "../../../context/AuthContext";
import "../ResourceProfile/ProfileCard.css";
import SkillSetV2 from "./SkillSetV2";
import CertificationSetV2 from "./CertificationSetV2";
import LanguageV2 from "./LanguageV2";
import AvailabilityV2 from "./AvailabilityV2";
import ContactDetails from "./ContactDetails";
import DocumentBoxV2 from "./DocumentBoxV2";
import CustomTabs from "./CustomTabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FIRM_IMAGE_BASE } from "../../../config/env";
import removeAccount from "../../../apis/removeAccount";
import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import updateProfileBasicInfoV2 from "../../../apis/updateProfileBasicInfoV2";

const ProfileCard = (props) => {
  const { userDetails } = useAuthContext();
  const firmType = JSON.parse(userDetails).firm_details?.firm_type;
  const user_primary_role = JSON.parse(userDetails).user_primary_role;
  const MySwal = swalWithBootstrapButtons(Swal);
  const user_slug = JSON.parse(userDetails).user_slug;

  const { resourceDetails, resourceSlug } = props;

  const [isEditingRole, setIsEditingRole] = useState(false);
  const [profileRole, setProfileRole] = useState(
    resourceDetails?.user_profile_role || ""
  );
  const [firstName, setFirstName] = useState(resourceDetails?.first_name || "");
  const [lastName, setLastName] = useState(resourceDetails?.last_name || "");
  const [show, setShow] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(
    FIRM_IMAGE_BASE + resourceDetails?.profile_image_path
  );
  const [hasFileToUpload, setHasFileToUpload] = useState(null);
  const [selectedFilePath, setSelectedFilePath] = useState(null);
  const [fileUploadError, setFileUploadError] = useState(false);
  const [fileUploadErrorMessage, setFileUploadErrorMessage] = useState(false);
  const [modalButtonDisabled, setModalButtonDisabled] = useState(false);

  const roleInputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        roleInputRef.current &&
        !roleInputRef.current.contains(event.target)
      ) {
        setIsEditingRole(false);
      }
    };

    if (isEditingRole) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditingRole]);

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleJobRoleChange = (e) => {
    setProfileRole(e.target.value);
  };

  const handleClose = () => {
    setShow(false);
    setHasFileToUpload(false);
    setUploadedFile(file);
    setSelectedFilePath(false);
    setFileUploadError(false);
    setFileUploadErrorMessage(false);
  };

  const handleCloseNameModal = () => {
    window.location.reload();
  };

  const handleShow = () => setShow(true);
  const handleShowNameChange = () => setShowNameModal(true);

  const hiddenFileInput = React.useRef(null);

  const handleFormSubmit = () => {
    let isInvalid = 0;
    let errMessage = [];

    if (firstName !== null) {
      if (firstName.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter first name");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter first name");
    }

    if (lastName !== null) {
      if (lastName.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter last name");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter last name");
    }

    if (profileRole !== null) {
      if (profileRole.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter job role");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter job role");
    }

    if (isInvalid === 1) {
    } else {
      submitForm();
    }
  };

  const submitForm = () => {
    let formData = {
      current_user_slug: user_slug,
      userSlug: resourceSlug,
      firstName: firstName,
      lastName: lastName,
      jobRole: profileRole,
    };

    try {
      updateProfileBasicInfoV2(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            toast.success(data.data.message);
            handleCloseNameModal();
          } else if (data.data.status === 0) {
            toast.error(data.data.message);
          } else {
            toast.error(
              "Error happened. Unable to update profile information."
            );
          }
        } else {
          toast.error(
            "Error happened. Unable to update your profile information"
          );
        }
      });
    } catch (error) {
      toast.error("Error happened. Network error happened.");
    }
  };

  const displayNameEditModal = () => {
    return (
      <Modal show={showNameModal} backdrop="static" keyboard={false} size="lg">
        <form name="image-upload-frm">
          <Modal.Header closeButton={false}>
            <span className="fw-bold-custom">Update Information</span>
          </Modal.Header>
          <Modal.Body>
            <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
              <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                <div className="form-input-holder">
                  <InputLebelComponent title="First Name" />
                  <div className="d-block">
                    <input
                      type="text"
                      className="form-control"
                      id="first-name"
                      placeholder="Enter first name"
                      onChange={handleFirstNameChange}
                      value={firstName}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                <div className="form-input-holder">
                  <InputLebelComponent title="Last Name" />
                  <div className="d-block">
                    <input
                      type="text"
                      className="form-control"
                      id="last-name"
                      placeholder="Enter last name"
                      onChange={handleLastNameChange}
                      value={lastName}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                <div className="form-input-holder">
                  <InputLebelComponent title="Job Role" />
                  <div className="d-block">
                    <input
                      type="text"
                      className="form-control"
                      id="job-role"
                      placeholder="Enter job role"
                      onChange={handleJobRoleChange}
                      value={profileRole}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleCloseNameModal}
              type="reset"
              disabled={modalButtonDisabled}
              size="sm"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleFormSubmit}
              disabled={modalButtonDisabled}
              size="sm"
            >
              Save Changes
            </Button>
            {displayImageUploadStatusMessage()}
          </Modal.Footer>
        </form>
      </Modal>
    );
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    setHasFileToUpload(true);
    setUploadedFile(URL.createObjectURL(fileUploaded));
    setSelectedFilePath(fileUploaded);
  };

  const handleSubmitImageUpload = () => {
    setFileUploadError(false);
    setFileUploadErrorMessage(false);

    if (selectedFilePath === null && hasFileToUpload === null) {
      setFileUploadError(false);
    } else {
      setModalButtonDisabled(true);
      uploadAvatar();
    }
  };

  const uploadAvatar = () => {
    let formData = {
      userSlug: resourceSlug,
      file: selectedFilePath,
    };

    try {
      userAvatarUpload(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            setUploadedFile(file);
            setFile(data.data.profile_image_path);
            setUploadedFile(data.data.profile_image_path);
            toast.success(data.data.message);
            setShow(false);
            setHasFileToUpload(false);
            setSelectedFilePath(false);
            setModalButtonDisabled(false);
          } else if (data.data.status === 0) {
            toast.warning(data.data.message);
            setModalButtonDisabled(false);
          } else {
            toast.warning("Network error happened. Please try again later");
            setModalButtonDisabled(false);
          }
        } else {
          toast.warning("Network error happened. Please try again later");
          setModalButtonDisabled(false);
        }
      });
    } catch (error) {}
  };

  const displayImageUploadModal = () => {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <form name="image-upload-frm">
          <Modal.Header closeButton={false}>
            <span className="fw-bold-custom">Change Profile Image</span>
          </Modal.Header>

          <Modal.Body>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div className="profile-image-upload-holder">
                <Image
                  className="profile-image-upload-holder-image"
                  src={uploadedFile}
                />
              </div>
              <div className="d-block mb-4 mt-2">
                <Button variant="warning" size="sm" onClick={handleClick}>
                  Upload Profile Image
                </Button>
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleChange}
                  style={{ display: "none" }}
                  accept="image/*"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleClose}
              type="reset"
              disabled={modalButtonDisabled}
              size="sm"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmitImageUpload}
              disabled={modalButtonDisabled}
              size="sm"
            >
              Save Changes
            </Button>
            {displayImageUploadStatusMessage()}
          </Modal.Footer>
        </form>
      </Modal>
    );
  };

  const displayImageUploadStatusMessage = () => {
    return <>{displayImageUploadErrorMessage()}</>;
  };

  const displayImageUploadErrorMessage = () => {
    if (fileUploadError) {
      return (
        <div className="d-block mt-4 w-100">
          <AlertDanger title={"Oops"} message={fileUploadErrorMessage} />
        </div>
      );
    }
  };

  const linkPath =
    user_primary_role === "3"
      ? `/resources/details/${resourceSlug}`
      : firmType === "1" && user_primary_role === "2"
      ? `/my-team/details/${resourceSlug}`
      : `/resources/details/${resourceSlug}`;

  const handleRemoveAccount = (resourceSlug) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "that you want to remove this account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        removeResource(resourceSlug);
      }
    });
  };

  const removeResource = (slug) => {
    let formData = {
      user_slug: user_slug,
      resource_slug: slug,
    };

    try {
      removeAccount(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            await MySwal.fire({
              title: <strong>Success</strong>,
              html: <i>{data.data.message}</i>,
              icon: "success",
            });

            window.location.href = "/resources";
          } else if (data.data.status === 0) {
            await MySwal.fire({
              title: <strong>Error</strong>,
              html: <i>{data.data.message}</i>,
              icon: "danger",
            });
          } else {
            await MySwal.fire({
              title: <strong>Error</strong>,
              html: <i>{data.data.status}</i>,
              icon: "danger",
            });
          }
        } else {
          await MySwal.fire({
            title: <strong>Error</strong>,
            html: <i>{data.data.message}</i>,
            icon: "danger",
          });
        }
      });
    } catch (error) {
      MySwal.fire({
        title: <strong>Success</strong>,
        html: <i>Something wrong happened!</i>,
        icon: "danger",
      });
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-end gap-3">
        <div className="btn-group" role="group" aria-label="View toggle">
          <Link to={linkPath}>
            <Button variant="outline-secondary" size="sm">
              Default View
            </Button>
          </Link>
        </div>
      </div>
      <div className="my-4">
        <div className="card">
          <div className="p-3 pb-0 d-flex flex-column flex-md-row align-items-start justify-content-between gap-3s">
            <div className="d-flex align-items-center">
              <div className="me-3 position-relative">
                <Image
                  className="profile-image-lg-rounder"
                  src={uploadedFile}
                />
                <div
                  className="position-absolute"
                  style={{ zIndex: 10, top: "-4px", right: "2px" }}
                >
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="text-primary cursor-pointer"
                    title="Edit Avatar"
                    role="button"
                    onClick={handleShow}
                  />
                </div>
              </div>
              <div className="d-flex">
                <div className="me-2">
                  <div className="text-md fw-bold">
                    {`${firstName} ${lastName}`}
                  </div>

                  <span
                    title="Click to edit"
                    onClick={() => setIsEditingRole(true)}
                    className="text-link cursor-pointer"
                  >
                    {profileRole || "Not set"}
                  </span>
                </div>
                <FontAwesomeIcon
                  icon={faEdit}
                  className="text-primary cursor-pointer"
                  title="Edit Skills"
                  role="button"
                  onClick={handleShowNameChange}
                />
              </div>
            </div>
            {user_slug !== resourceSlug && (
              <Button
                variant="danger"
                size="sm"
                className=""
                onClick={() => handleRemoveAccount(resourceSlug)}
              >
                Delete Account
              </Button>
            )}
          </div>

          <ContactDetails resourceDetails={resourceDetails} />

          <div className="row text-md-left p-3 border-top">
            <div className="col-md">
              <SkillSetV2
                skillDetails={resourceDetails.skill_details}
                skillCount={resourceDetails.skill_count}
                skillFormattedSet={resourceDetails.skill_formatted_set}
                resourceSlug={resourceSlug}
                profileName={`${resourceDetails?.first_name} ${resourceDetails?.last_name}`}
              />
            </div>
            <div className="col-md divider-col">
              <CertificationSetV2
                certificationDetails={resourceDetails.certification_details}
                resourceSlug={resourceSlug}
              />
            </div>
            <div className="col-md divider-col">
              <LanguageV2
                languageDetails={resourceDetails.language_details_V2}
                resourceSlug={resourceSlug}
                profileName={`${resourceDetails?.first_name} ${resourceDetails?.last_name}`}
              />
            </div>
            <div className="col-md divider-col">
              <AvailabilityV2
                availabilityDetails={resourceDetails.availability_details}
                resourceSlug={resourceSlug}
              />
            </div>
            <div className="col-md divider-col">
              <DocumentBoxV2
                documentDetails={resourceDetails.document_details}
                resourceSlug={resourceSlug}
              />
            </div>
          </div>
        </div>
      </div>
      <CustomTabs resourceDetails={resourceDetails} />
      {displayImageUploadModal()}
      {displayNameEditModal()}
    </>
  );
};

export default ProfileCard;
